import { Action } from "../actions/actions";
import { SkeletonActionTypes } from "../actions/actionTypes";
import { Route } from "../api/apiTypes";
import { SubAppConfig } from "./subAppsConfig.reducer";

export function activeSubApps(
    state: SubAppConfig[] = [],
    action: Action
): SubAppConfig[] {
    switch (action.type) {
        case SkeletonActionTypes.UPDATE_ACTIVE_SUBAPPS:
        case SkeletonActionTypes.INITIALIZE_SUCCESS:
            // get list of names of the services that are available
            const availableRoutes: string[] = (
                Object.values(action.payload.routes) as Route[]
            ).reduce((accumulator, route) => {
                if (
                    route.extra &&
                    route.extra.service &&
                    accumulator.indexOf(route.extra.service) === -1
                ) {
                    accumulator.push(route.extra.service);
                }

                return accumulator;
            }, []);

            return (
                Object.values(action.payload.subAppsConfig) as SubAppConfig[]
            ).filter(subApp => {
                const hasServices =
                    subApp.services &&
                    subApp.services.length > 0 &&
                    subApp.services.reduce(
                        (accumulator, service) =>
                            accumulator || availableRoutes.includes(service),
                        false
                    );
                const hasRoutes =
                    subApp.routes &&
                    subApp.routes.length > 0 &&
                    subApp.routes.reduce((accumulator, route) => {
                        return (
                            accumulator ||
                            action.payload.routes.find(
                                availableRoute => availableRoute.name == route
                            )
                        );
                    }, false);

                const dontHave = !subApp.routes && !subApp.services;

                return subApp.listable && (hasServices || hasRoutes || dontHave)
                    ? subApp
                    : undefined;
            });

        default:
            return state;
    }
}
